/**
 * Opens the Helio AI storefront widget when elements with [data-tradeuno-open-helio] are clicked.
 * Tries common globals/selectors; falls back to clicking the launcher button if found.
 */
(function () {
  if (window.__tradeunoHelioAskInit) return;
  window.__tradeunoHelioAskInit = true;

  function tryCall(obj, paths) {
    var cur = obj;
    for (var i = 0; i < paths.length; i++) {
      if (cur == null) return false;
      cur = cur[paths[i]];
    }
    if (typeof cur === 'function') {
      try {
        cur();
        return true;
      } catch (e) {}
    }
    return false;
  }

  function openHelioChat() {
    var g = window;
    if (tryCall(g, ['helio', 'open'])) return;
    if (tryCall(g, ['Helio', 'open'])) return;
    if (tryCall(g, ['helioAI', 'open'])) return;
    if (tryCall(g, ['HelioAI', 'openChat'])) return;
    if (tryCall(g, ['__HELIO__', 'open'])) return;
    if (tryCall(g, ['helioWidget', 'open'])) return;

    var selectors = [
      '[data-helio-launcher]',
      '[data-tradeuno-helio-launcher]',
      'button#helio-widget-button',
      '#helio-widget-button',
      '[id*="helio"][class*="launcher"]',
      '[class*="helio-launcher"]',
      '[class*="HelioLauncher"]',
    ];
    for (var s = 0; s < selectors.length; s++) {
      var el = document.querySelector(selectors[s]);
      if (el && typeof el.click === 'function') {
        el.click();
        return;
      }
    }

    var candidates = document.querySelectorAll(
      'button[aria-label*="chat" i], button[aria-label*="Helio" i], [role="button"][aria-label*="chat" i]'
    );
    for (var c = 0; c < candidates.length; c++) {
      var btn = candidates[c];
      var rect = btn.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0 && typeof btn.click === 'function') {
        var cls = (btn.className && btn.className.toString()) || '';
        var id = btn.id || '';
        if (/helio/i.test(cls + id) || (rect.bottom > window.innerHeight * 0.5 && rect.right > window.innerWidth * 0.6)) {
          btn.click();
          return;
        }
      }
    }

    try {
      window.dispatchEvent(new CustomEvent('helio:open', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('helio-open-chat', { bubbles: true }));
    } catch (e) {}
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target.closest('[data-tradeuno-open-helio]');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      openHelioChat();
    },
    true
  );
})();
